import {
	type LeCoffreAuthContext,
} from "@Front/Utils/lecoffreSessionCookieHelpers";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { resolveAccessTokenForEndpoint } from "@Front/Api/helpers/authTokenResolutionHelpers";
import { ContentType } from "../ContentType";

/** JSON-only headers for unauthenticated public API routes (no Bearer token). */
export function buildPublicApiJsonHeaders(): Headers {
	const headers = new Headers();
	headers.set("Content-Type", ContentType.JSON);
	return headers;
}

function logMissingTokenInStores(context: LeCoffreAuthContext, endpoint?: string): void {
	if (typeof window === "undefined") {
		return;
	}
	LoggerService.debug("[BaseApiService] No token in cookie or stores (expected for public requests)", {
		allCookiesLength: document.cookie.length,
		authContext: context,
		endpoint: endpoint ?? null,
	});
}

function appendContentTypeHeader(headers: Headers, contentType: ContentType): void {
	if (contentType === ContentType.JSON || contentType === ContentType.PDF) {
		headers.set("Content-Type", contentType);
	}
}

function appendAuthorizationHeader(headers: Headers, token: string | null, contentType: ContentType): void {
	if (!token && typeof window !== "undefined") {
		LoggerService.debug("⚠️ [BaseApiService] No access token cookie available for request (expected for public endpoints)", {
			contentType,
			hasWindow: true,
			hasDocument: typeof document !== "undefined",
		});
		return;
	}
	if (token) {
		headers.set("Authorization", `Bearer ${token}`);
	}
}

export function buildHeaders(contentType: ContentType, endpoint?: string): Headers {
	const { context, token } = resolveAccessTokenForEndpoint(endpoint);
	if (!token) {
		logMissingTokenInStores(context, endpoint);
	}
	const headers = new Headers();
	appendContentTypeHeader(headers, contentType);
	appendAuthorizationHeader(headers, token, contentType);
	return headers;
}
